const GET_COUNTRIES = "GET_COUNTRIES";
const SET_USERDATA  = "SET_USERDATA";
const IS_LOADING    = "IS_LOADING";
const SET_CUSTOM_COUNTRY_CODE    = "SET_CUSTOM_COUNTRY_CODE";
const HANDLE_CHANGE    = "HANDLE_CHANGE";
const SET_REPORT_ID    = "SET_REPORT_ID";
const SET_RESPONSE_MESSAGE    = "SET_RESPONSE_MESSAGE";
const IS_MENU_OPEN    = "IS_MENU_OPEN";

const initialState = {
    location:[],
    countries:[],
    userName:'',
    userMail:'',
    userPhone:'',
    userMessage:'',
    privacyAccept: false,
    responseMessage: null,
    reportId:null,
    isLoading: false,
    mobile_menu_open: false
};

/**
 * Start Callbacks
 **/

const setReportID = (state, ID) => {
    let stateCopy = {...state};
    stateCopy.reportId = ID;
    return stateCopy;
};

const setResponseMessage = (state, Message) => {
    let stateCopy = {...state};
    stateCopy.responseMessage = Message;
    return stateCopy;
};

function handleChange (state, e, { value, target }) {
    let stateCopy = {...state};
    stateCopy[target] = {...state[target]};
    stateCopy[target] = value;
    return stateCopy;
}

function setCountries(state, countries) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.countries = countries;
    return stateCopy;
}

function setUserData(state, userData) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.location = userData;
    return stateCopy;
}

function toggleLoading(state, isLoading) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.isLoading = isLoading;
    return stateCopy;
}

function setCustomCountryCode(state, e, { value }) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    delete stateCopy.location.city;
    delete stateCopy.location.region;
    delete stateCopy.location.regionName;
    delete stateCopy.location.timezone;
    delete stateCopy.location.zip;
    stateCopy.location.country = e.target.innerText;
    stateCopy.location.countryCode = value;
    stateCopy.location.status = "custom";
    return stateCopy;
}

/**
 * End of Callbacks
 **/

const userDataReducer = (state = initialState, action) => {

    switch (action.type) {
        case IS_MENU_OPEN:
            return {...state, mobile_menu_open: action.value };
        case GET_COUNTRIES:
            return setCountries(state, action.countries);
        case SET_RESPONSE_MESSAGE:
            return setResponseMessage(state, action.message);
        case SET_USERDATA:
            return setUserData(state, action.userData);
        case IS_LOADING:
            return toggleLoading(state, action.isLoading);
        case SET_CUSTOM_COUNTRY_CODE:
            return setCustomCountryCode(state, action.e, action.data);
        case HANDLE_CHANGE:
            console.log(action.data.checked);
            let value = (action.data.target === "privacyAccept" ? action.data.checked : action.data.value);
            return {...state, [action.data.target]: value};
        case SET_REPORT_ID:
            return setReportID(state, action.id);
        default:
            return state;
    }
}

/**
 * ACTIONS
 */

export function isMenuOpenAction(value) {
    return {type: IS_MENU_OPEN, value};
}

export function getCountriesAction(countries) {
    return {type: GET_COUNTRIES, countries:countries};
}
export function setResponseMessageAction(message) {
    return {type: SET_RESPONSE_MESSAGE, message};
}
export function setUserDataAction(UserData) {
    return {type: SET_USERDATA, userData:UserData};
}
export function isLoadingAction(isLoading) {
    return {type: IS_LOADING, isLoading};
}
export function setCustomCountryCodeAction(event, data) {
    return {type: SET_CUSTOM_COUNTRY_CODE, e: event, data:data};
}
export function handleChangeAction(event, data) {
    return {type: HANDLE_CHANGE, e: event, data};
}
export function setReportIdAction(id) {
    return {type: SET_REPORT_ID, id};
}

export default userDataReducer;